import { useEffect, useState } from "react";
import Modal from "./modal";
import Spinner from "./spinner";
import ReactDatePicker from "react-datepicker";
import { he } from "date-fns/locale";
import styles from "../styles/_components/createCouponModal.module.scss";
import ReactSwitch from "react-switch";
import SERVICES from "../api/services/SERVICES";
import { format } from "date-fns";
import { toast } from "react-toastify";
import COUPONS from "../api/services/COUPONS";

const CreateCouponModal = ({ setIsOpen, setResponseStatus }) => {
  const [name, setName] = useState("");
  const [priceType, setPriceType] = useState("");
  const [price, setPrice] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [allowMultipleUsesPerUser, setAllowMultipleUsesPerUser] =
    useState(false);
  const [quantity, setQuantity] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [validService, setValidService] = useState("");
  const [validServices, setValidServices] = useState([]);
  const [phone, setPhone] = useState("");

  const [loading, setLoading] = useState("");

  const [services, setServices] = useState([]);

  const handleCreateCoupon = async () => {
    let payload = {
      name,
      priceType,
      price,
      expiryDate: format(new Date(expiryDate), "yyyy-MM-dd"),
      allowMultipleUsesPerUser,
      isActive,
      validServices,
    };

    if (quantity) {
      payload.quantity = quantity;
    }

    if (phone) {
      payload.phoneNumber = phone;
    }

    try {
      setLoading(true);
      const res = await COUPONS.create_coupon(payload);
      toast.success(res.data.message);
      setIsOpen(false);
      setResponseStatus(true);
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  let businessId = localStorage.getItem("user_id");
  businessId = JSON.parse(businessId);

  // FETCH SERVICES
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await SERVICES.get_all({ business_id: businessId });
        setServices(res.data.data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);

  return (
    <Modal setIsOpen={setIsOpen} onClick={() => null} type={1}>
      <div className={styles.container}>
        {/* NAME */}
        <div className={styles.field}>
          <input
            type="text"
            name="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="קוד הקופון *"
          />
        </div>

        {/* PRICE TYPE */}
        <div className={styles.field}>
          <select
            name="priceType"
            value={priceType}
            onChange={(e) => setPriceType(e.target.value)}
          >
            <option value="" disabled selected>
              סוג ההנחה *
            </option>
            <option value="fixedPrice">סכום</option>
            <option value="percentage">אחוזי הנחה</option>
          </select>
        </div>

        {/* PRICE */}
        <div className={styles.field}>
          <input
            type="number"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            placeholder="מחיר *"
          />
        </div>

        {/* QUANTITY */}
        <div className={styles.field}>
          <input
            type="number"
            name="quantity"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            placeholder="כמות "
          />
        </div>

        {/* EXPIRY DATE */}
        <div className={styles.field}>
          <ReactDatePicker
            selected={expiryDate}
            onChange={setExpiryDate}
            locale={he}
            placeholderText="תוקף*"
            wrapperClassName={styles.exp}
            minDate={new Date()}
          />
        </div>

        {/* PHONE */}
        <div className={styles.field}>
          <input
            name="phone"
            type="number"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="מספר טלפון לשליחה"
          />
        </div>

        {/* SWITCH ROW */}
        <div className={styles.switchRow}>
          {/* STATUS */}
          <div className={styles.switchContainer}>
            <ReactSwitch
              checked={isActive}
              onChange={(e) => {
                setIsActive(e);
              }}
              checkedHandleIcon={false}
              uncheckedHandleIcon={false}
              checkedIcon={false}
              uncheckedIcon={false}
              onHandleColor={"#ffffff"}
              offHandleColor={"#ffffff"}
              onColor={"#d00254"}
              offColor={"#d3d3d3"}
              className={styles.switch}
            />
            <p>סטטוס</p>
          </div>

          {/* ALLOW MULTIPLE USES PER USER */}
          <div className={styles.switchContainer}>
            <ReactSwitch
              checked={allowMultipleUsesPerUser}
              onChange={(e) => {
                setAllowMultipleUsesPerUser(e);
              }}
              checkedHandleIcon={false}
              uncheckedHandleIcon={false}
              checkedIcon={false}
              uncheckedIcon={false}
              onHandleColor={"#ffffff"}
              offHandleColor={"#ffffff"}
              onColor={"#d00254"}
              offColor={"#d3d3d3"}
              className={styles.switch}
            />
            <p>האם לקוח יוכל לממש יותר מפעם אחת?</p>
          </div>
        </div>

        {/* VALID SERVICES */}
        <div className={styles.field}>
          <select
            name="validService"
            value={validService}
            onChange={(e) => {
              setValidService(e.target.value);
              if (!validServices.includes(e.target.value)) {
                setValidServices((prev) => [...prev, e.target.value]);
              }
            }}
          >
            <option value="" disabled selected>
            הקצאה לשירותים ספציפים
            </option>
            {services?.map((i) => (
              <option key={i._id} value={i._id}>
                {i.name}
              </option>
            ))}
          </select>
        </div>

        {/* SERVICES BOX */}
        <div className={styles.box}>
          {validServices.length > 0 ? (
            validServices.map((i) => (
              <div
                className={styles.service}
                onClick={() =>
                  setValidServices((prev) => prev.filter((x) => x !== i))
                }
                key={i}
              >
                <span>x</span>
                {services?.find((j) => j._id === i)?.name}
              </div>
            ))
          ) : (
            <p>ניתן לממש בכל השירותים</p>
          )}
        </div>

        <button
          onClick={handleCreateCoupon}
          disabled={!name || !priceType || !price || !expiryDate}
          className={styles.button}
        >
          {loading ? <Spinner /> : "יצירה"}
        </button>
      </div>
    </Modal>
  );
};

export default CreateCouponModal;
